import PageHeader from '../../../../components/layout/PageHeader';
import QueuesList from './queue/QueuesList';

const QueuesPage = () => {
    return (
        <div className="ms-Grid" dir="ltr">
            <PageHeader text="Eilės" />
            <div className="ms-Grid-row" style={{ paddingTop: '10px' }}>
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                    <QueuesList />
                </div>
            </div>
        </div>
    );
};

export default QueuesPage;
